import { createFileRoute, redirect } from "@tanstack/react-router";

/** Answers is Xamseen's name for the questions & solutions layer. */
export const Route = createFileRoute("/answers")({
  beforeLoad: () => { throw redirect({ to: "/questions" }); },
});
